/* eslint-disable @typescript-eslint/no-explicit-any */
export function isInWebView() {
  const userAgent = navigator.userAgent || navigator.vendor; // || window.opera;
  return (
    /WebView|iPhone|iPad|Android/i.test(userAgent) ||
    typeof (window as any).ReactNativeWebView !== "undefined"
  );
}
